import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../features/webStorageSaver";

export default function MissingPage() {
    const navigate = useNavigate();
    const currentConfig = getItemWebStorage('currentConfig')
    const localHostFlag = window.location.hostname === 'localhost'
   
    function goBackToHome() {
        navigate('/app/roads/list')
    }

    function getLogoSrc(){
        const logo = currentConfig?.logo
        let logoPath
        let urlParsed: any
        urlParsed = logo.split('/')
        let logoName = urlParsed[urlParsed.length - 1]
        logoPath = urlParsed.includes('logos') ? `logos/${logoName}` : `${logoName}`
        try{
            return require(`../../assets/images/${logoPath}`)
        } catch{
            console.error(`Ошибка загрузки изображения ${logoPath}`)
        }
    }

    return (
        <div className="missing-page-div">
            <div className="missing-page-block">
                <div className="missing-page-text">
                    <h3>Страница не найдена...</h3>
                    <p>Извините! Страница, которую Вы ищете, не может быть найдена.</p>
                    <p>Чтобы найти интересующую Вас информацию – перейдите на главную страницу.</p>
                    <button className="go-home-button" onClick={goBackToHome}>На главную</button>
                </div>
                <div className="missing-page-logo">
                    <img src={getLogoSrc()} alt="Логотип" className="header-logo-icon" />
                </div>
            </div>
        </div>
    )
}
